import React from "react";
import { motion } from "framer-motion";
import { Star, Quote } from "lucide-react";
import { TESTIMONIALS } from "../mock";

const Testimonials = () => {
  return (
    <section id="avis" className="section-pad relative bg-[#08080a] overflow-hidden">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.2 }}
          transition={{ duration: 0.6 }}
          className="text-center max-w-2xl mx-auto mb-16"
        >
          <span className="eyebrow justify-center">Témoignages</span>
          <h2 className="section-title text-4xl md:text-6xl text-white mt-5">
            Ils m'ont fait <span className="racing-text">confiance</span>
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {TESTIMONIALS.map((t, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.25 }}
              transition={{ delay: i * 0.12, duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
              className="card-lift glass rounded-2xl p-7 relative"
            >
              <Quote size={38} className="text-[#e11d2a]/25 absolute top-5 right-5" />
              <div className="flex gap-1 mb-4">
                {Array.from({ length: t.rating }).map((_, idx) => (
                  <Star key={idx} size={16} className="text-[#ff6a00]" fill="#ff6a00" />
                ))}
              </div>
              <p className="text-white/75 leading-relaxed text-[15px]">“{t.text}”</p>
              <div className="mt-6 flex items-center gap-3">
                <div className="w-11 h-11 rounded-full bg-gradient-to-br from-[#e11d2a] to-[#ff6a00] flex items-center justify-center font-display font-bold text-white">
                  {t.name.charAt(0)}
                </div>
                <div>
                  <p className="font-display font-semibold text-white">{t.name}</p>
                  <p className="text-white/45 text-sm">{t.city}</p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
